import * as Utils from './utils';

const body = document.body,
      siteUrl = document.location.origin,
      loadButton = document.querySelectorAll(".js-load-button"),
      filterList = document.querySelector("ul.filters"),
      categoryButton = document.querySelectorAll(".js-reload-posts"),
      postContainer = document.querySelector(".js-post-container");

let postRows = 4;

function loadMorePosts() {
  let numPosts = (postRows%2 == 0) ? 3 : 4;

  let hiddenPosts = postContainer.querySelectorAll(".hidden");

  for (var i = 0; i < numPosts; i++) {
    // Check post exists, in case there is less than 3 or 4
    if(typeof hiddenPosts[i] !== "undefined") {
      hiddenPosts[i].classList.add('delay-'+i);
      hiddenPosts[i].classList.remove('hidden');
    } else {
      // If we have an incomplete row, hide button
      toggleLoadButton('hide');
    }
  }

  // Check whether there's any remaining elements
  hiddenPosts = postContainer.querySelectorAll(".hidden");
  if(hiddenPosts.length == 0) {
    toggleLoadButton('hide');
  }

  postRows++;
}

function changeCategory(e) {
  e.preventDefault();

  var el = e.target;
  var tag = el.classList.contains('active') ? '' : el.dataset.tag;

  let ajaxUrl = siteUrl + '/wp-admin/admin-ajax.php';

  postContainer.classList.add('loading');
  resetFilterState();

  el.classList[tag == '' ? 'remove' : 'add']('active');
  filterList.classList[tag == '' ? 'remove' : 'add']('selected');

  var request = new XMLHttpRequest();

    request.open('POST', ajaxUrl, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
    request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
            // If successful
            postContainer.innerHTML = this.response;
            postContainer.classList.remove('loading');

            if(postContainer.childElementCount > 14) {
              toggleLoadButton('show');
            } else {
              toggleLoadButton('hide');
            }

            Utils.animateInViewEls('.js-watch', 'in-view', 0.1);
            Utils.searchForImages(postContainer);
            resetPostRows();
        } else {
            // If fail
            console.log(this.response);
        }
    };
    request.onerror = function() {
        // Connection error
    };
    request.send('action=storyload&live-tag=' + tag);
    //
}

function toggleLoadButton(action) {
  loadButton.forEach(el => {
      el.classList[action == 'show' ? 'remove' : 'add']('hidden');
  });
}

function resetFilterState() {
  categoryButton.forEach(el => {
    el.classList.remove('active');
  });
}

function resetPostRows() {
  postRows = 4;
}

export function init() {

loadButton.forEach(el => {
    el.addEventListener('click', loadMorePosts);
});

categoryButton.forEach(el => {
    el.addEventListener('click', changeCategory);
});

}
